import React from 'react';
import PropTypes from 'prop-types';
import {
  InfoRow as BaseRow,
  styles as baseStyles,
} from '../../core/Row/InfoRow';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import T from 'i18n-react';
import { ProgressButton } from '../../core/Button';
import RequiredChip from './RequiredChip';
import EditImage from '../../../images/user/pencil.png';
import clsx from 'clsx';

const merge = require('lodash/merge');

const styles = (theme) => ({
  ...merge({}, baseStyles(theme), {
    container: {
      borderBottom: `1px dotted ${theme.palette.text.secondary}`,
    },
    editContent: {
      backgroundColor: theme.props.backgroundColor.primary.main,
      borderRadius: 10,
      marginTop: theme.spacing(2),
      padding: theme.spacing(4),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2),
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2),
      '& > *:nth-child(n + 2)': {
        marginLeft: theme.spacing(1),
      },
    },
    titleChild: {
      display: 'flex',
      alignItems: 'center',
      '& > *:first-child': {
        paddingRight: theme.spacing(1),
      },
      [theme.breakpoints.up('sm')]: {
        '& > *:nth-child(2)': {
          marginLeft: 'auto',
        },
      },
    },
  }),
});

class InfoRow extends BaseRow {
  state = {
    ...super.state,
    progress: false,
  };

  editButtonProps = {
    startIcon: (
      <img src={EditImage} style={{ width: 20, height: 20 }} alt="edit" />
    ),
  };

  titleChildrenRenderer() {
    const { classes, title, prompt } = this.props;
    return (
      <div className={classes.titleChild}>
        <div>{title}</div>
        {prompt && <RequiredChip />}
      </div>
    );
  }

  textChildrenRenderer() {
    const { disableLineTruncate } = this.props;
    return (
      <span className={clsx(!disableLineTruncate && 'line-truncate-2')}>
        {this.props.text}
      </span>
    );
  }

  handleCancel = () => {
    this.setState({ edit: false, progress: false });
    this.props.onCancel?.();
  };

  handleSave = () => {
    const { onSave } = this.props;
    if (!onSave) return;

    this.setState({ progress: true });
    onSave(
      () => this.setState({ progress: false, edit: false }),
      () => this.setState({ progress: false }),
    );
  };

  editContentRenderer() {
    const {
      classes,
      editContent,
      disableButton = false,
      buttonText,
    } = this.props;
    const { progress } = this.state;

    return (
      <div>
        {editContent}
        <div className={classes.buttonContainer}>
          <Button
            disabled={progress}
            variant="contained"
            disableElevation
            onClick={this.handleCancel}
          >
            {T.translate('cancel')}
          </Button>
          <ProgressButton
            progress={progress}
            disabled={
              (typeof disableButton === 'function'
                ? disableButton()
                : disableButton) || progress
            }
            variant="contained"
            color="primary"
            disableElevation
            onClick={this.handleSave}
          >
            {buttonText || T.translate('save')}
          </ProgressButton>
        </div>
      </div>
    );
  }
}

InfoRow.propTypes = {
  ...BaseRow.propTypes,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  disableButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  buttonText: PropTypes.string,
  prompt: PropTypes.bool,
  disableLineTruncate: PropTypes.bool,
};

export default withStyles(styles)(InfoRow);
